module.exports = __webpack_public_path__ + "static/img/0544_1.e4090a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0544_1.jpg
// module id = 7xsp
// module chunks = 1